<template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>TOKENS</h2>
				</div>
				<v-btn @click.prevent="fncTokenAdd" class="elevation-5" color="info"><i class="material-icons">add</i>Create Token</v-btn>
				<v-btn @click.prevent="fncReloadTokens" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
			}
		},
		methods: {
          fncTokenAdd() {
              var modalDetails = { title: 'Add Token', component: 'modal-token-add', mstate: true, params: {} };
              this.$store.commit({
                type: 'setModal',
                details: modalDetails
              });
          },
          fncReloadTokens() {
            this.$store.commit('fncEmptyTokens');
            this.$store.dispatch({
              type: 'fncPopulateTokens',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
